import { dataHooks } from '@wix/data-hooks'

export const wixVibeSplitDataHooks = dataHooks<{
  title: {}
  option: { key: string }
}>('wix-vibe-split')
